"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CarLined = function CarLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.5 8H21a.453.453 0 00-.064.013.413.413 0 00-.063.013.5.5 0 00-.227.121l-.786.786-2.349-3.758A2.483 2.483 0 0015.392 4H8.608a2.483 2.483 0 00-2.119 1.175L4.14 8.933l-.786-.786a.492.492 0 00-.226-.121.47.47 0 00-.063-.013A.467.467 0 003 8H1.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.973l-1.245 1.992a1.5 1.5 0 00-.228.8V19.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5V17h12v2.5a.5.5 0 00.5.5h3a.5.5 0 00.5-.5v-6.713a1.5 1.5 0 00-.228-.795L20.527 10H22.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM7.336 5.705A1.493 1.493 0 018.608 5h6.784a1.493 1.493 0 011.272.705L18.723 9H5.277zM5 19H3v-2h2zm16 0h-2v-2h2zm0-6.213V16H3v-3.213a.5.5 0 01.076-.265L4.652 10h14.7l1.576 2.521a.5.5 0 01.072.266zm-6 .713a.5.5 0 01-.5.5h-5a.5.5 0 010-1h5a.5.5 0 01.5.5zM6.969 13a1 1 0 11-1-1 1 1 0 011 1zm12 0a1 1 0 11-1-1 1 1 0 01.998 1z",
    fill: "currentColor"
  })));
};

var _default = CarLined;
exports["default"] = _default;